<template>
  <div style="height: 100%">
    <template v-if="isCreateOrUpdate">
      <ValidationObserver class="automation" ref="form" v-slot="{handleSubmit, invalid}">
        <div class="automation__form">
          <div class="automation__title">{{ $t('automation.parameters') }}</div>

          <vs-row>
            <vs-col
              vs-w="12"
              vs-sm="6"
              vs-lg="3"
              vs-xs="12"
            >
              <div class="m-2">
                <ValidationProvider vid="name" :name="$t('global.title')" rules="required" v-slot="{ errors }">
                  <label class="text-sm opacity-75">{{ $t('global.title') }} *</label>
                  <vs-input
                    class="inputx w-full no_focus"
                    :placeholder="$t('global.Name')"
                    v-model="fields.name"
                  />
                  <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                </ValidationProvider>
              </div>
            </vs-col>
          </vs-row>

            <CronScheduler v-model="fields.cronExpression" />

            <div class="automation__title">{{ $t('global.leadSamplingParameters') }}</div>

            <vs-row vs-type="flex">
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">{{ $t('global.Status') }}</label>
                        <v-select
                            v-model="fields.group_statuses"
                            :options="options.statuses"
                            :placeholder="$t('global.Status')"
                            :clearable="true"
                            :closeOnSelect="false"
                            multiple
                        />
                    </div>
                </vs-col>
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">{{ $t('global.Integration') }}</label>
                        <v-select
                            v-model="fields.advertiser_integration_ids"
                            :options="options.advertiser_integrations"
                            :placeholder="$t('global.Integration')"
                            :clearable="true"
                            :closeOnSelect="false"
                            label="name"
                            :reduce="a => a.id"
                            multiple
                        />
                    </div>
                </vs-col>
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">{{ $t('global.Affiliate') }}</label>
                        <v-select
                            v-model="fields.affiliate_ids"
                            :options="options.affiliates"
                            :placeholder="$t('global.Affiliate')"
                            :clearable="true"
                            :closeOnSelect="false"
                            :reduce="a => a.id"
                            label="name"
                            multiple
                        />
                    </div>
                </vs-col>
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">{{ $t('global.Landings') }}</label>
                        <v-select
                            v-model="fields.landings"
                            :options="options.landings"
                            :placeholder="$t('global.Landings')"
                            :clearable="true"
                            :closeOnSelect="false"
                            :reduce="a => a.name"
                            label="name"
                            multiple
                        />
                    </div>
                </vs-col>
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">{{ $t('global.Country') }}</label>
                        <v-select
                            v-model="fields.countries"
                            :options="options.countries"
                            :placeholder="$t('global.Country')"
                            :clearable="true"
                            :closeOnSelect="false"
                            :reduce="a => a.iso_2"
                            label="iso_2"
                            multiple
                        />
                    </div>
                </vs-col>
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">{{ $t('global.Language') }}</label>
                        <v-select
                            v-model="fields.languages"
                            :options="options.languages"
                            :placeholder="$t('global.Language')"
                            :clearable="true"
                            :closeOnSelect="false"
                            :reduce="a => a.iso_2"
                            label="iso_2"
                            multiple
                        />
                    </div>
                </vs-col>
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">{{ $t('global.Manager') }}</label>
                        <v-select
                            v-model="fields.manager_ids"
                            :options="options.managers"
                            :placeholder="$t('global.Manager')"
                            :clearable="true"
                            :closeOnSelect="false"
                            :reduce="a => a.id"
                            label="name"
                            multiple
                        />
                    </div>
                </vs-col>
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <ValidationProvider
                          vid="relative_number_of_days_in_period_start"
                          :name="$t('automation.relative_number_of_days_in_period_start')"
                          :rules="{
                            required: true,
                            numeric: true,
                            minNum: 0,
                            maxNum: 90,
                            gte: {
                              target: fields.relative_number_of_days_in_period_end,
                              targetName: $t('automation.relative_number_of_days_in_period_end')
                            }
                          }"
                          v-slot="{ errors }"
                        >
                            <label class="text-sm opacity-75">{{ $t('automation.relative_number_of_days_in_period_start') }} *</label>
                            <vs-input
                                class="inputx w-full no_focus"
                                :placeholder="$t('automation.number_of_days')"
                                v-model.number="fields.relative_number_of_days_in_period_start"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </ValidationProvider>
                    </div>
                </vs-col>

              <vs-col
                vs-w="12"
                vs-sm="6"
                vs-lg="3"
                vs-xs="12"
              >
                <div class="m-2">
                  <ValidationProvider
                    vid="relative_number_of_days_in_period_end"
                    :name="$t('automation.relative_number_of_days_in_period_end')"
                    rules="required|integer|minNum:0|maxNum:90"
                    v-slot="{ errors }"
                  >
                    <label class="text-sm opacity-75">{{ $t('automation.relative_number_of_days_in_period_end') }} *</label>
                    <vs-input
                      class="inputx w-full no_focus"
                      :placeholder="$t('automation.number_of_days')"
                      v-model.number="fields.relative_number_of_days_in_period_end"
                    />
                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                  </ValidationProvider>
                </div>
              </vs-col>
            </vs-row>

            <div class="automation__title">{{ $t('global.sendingOptions') }}</div>

            <vs-row>
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <ValidationProvider vid="team_id" :name="$t('global.Team')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{ $t('global.Team') }} *</label>
                            <v-select
                                v-model="fields.team_id"
                                :options="options.teams"
                                :placeholder="$t('global.Team')"
                                :clearable="true"
                                :reduce="a => a.id"
                                label="name"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </ValidationProvider>
                    </div>
                </vs-col>

                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <ValidationProvider vid="advertiser_integration_id" :name="$t('global.Integration')"
                                            rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{ $t('global.Integration') }} *</label>
                            <v-select
                                v-model="fields.advertiser_integration_id"
                                :options="options.advertiser_integrations"
                                :placeholder="$t('global.Integration')"
                                :clearable="true"
                                label="name"
                                :reduce="a => a.id"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </ValidationProvider>
                    </div>
                </vs-col>

                <vs-col
                  vs-w="12"
                  vs-sm="6"
                  vs-lg="3"
                  vs-xs="12"
                >
                    <div class="m-2">
                      <label class="text-sm opacity-75">{{ $t('global.Country') }}</label>
                      <v-select
                        v-model="fields.country"
                        :options="options.countries"
                        :placeholder="$t('global.Country')"
                        :clearable="true"
                        label="iso_2"
                        :reduce="a => a.iso_2"
                      />
                    </div>
                </vs-col>

                <vs-col
                  vs-w="12"
                  vs-sm="6"
                  vs-lg="3"
                  vs-xs="12"
                >
                  <div class="m-2">
                    <label class="text-sm opacity-75">{{ $t('global.Language') }}</label>
                    <v-select
                      v-model="fields.language"
                      :options="options.languages"
                      :placeholder="$t('global.Language')"
                      :clearable="true"
                      label="iso_2"
                      :reduce="a => a.iso_2"
                    />
                  </div>
                </vs-col>

                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <ValidationProvider vid="leads_per_time" name="Per time" rules="required" v-slot="{ errors }">
                            <div class="vs-input--label mb-1">Per time *</div>
                            <vs-input
                                v-model.number="fields.leads_per_time"
                                class="inputx w-full"
                                @keypress="onKeypress($event)"
                                @input="onKeypressInput(fields.leads_per_time, 'leads_per_time')"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <ValidationProvider vid="leads_timespan_in_minutes" name="Timespan" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">Timespan *</label>
                            <v-select
                                v-model="fields.leads_timespan_in_minutes"
                                :options="timespanOptions"
                                placeholder="Timespan"
                                :clearable="true"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </ValidationProvider>
                    </div>
                </vs-col>

              <vs-col
                vs-w="12"
                vs-sm="6"
                vs-lg="3"
                vs-xs="12"
              >
                <div class="m-2">
                  <ValidationProvider vid="leads_count" :name="$t('automation.leads_count')" rules="minNum:0|maxNum:500" v-slot="{ errors }">
                    <label class="text-sm opacity-75">{{ $t('automation.leads_count') }}</label>

                    <vs-input
                      v-model.number="fields.leads_count"
                      class="inputx w-full"
                      @keypress="onKeypress($event)"
                      @input="onKeypressNullableInput(fields.leads_count, 'leads_count')"
                    />

                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                  </ValidationProvider>
                </div>
              </vs-col>
            </vs-row>
        </div>

        <vs-row class="automation__actions">
              <vs-col
                  vs-w="12"
                  vs-sm="12"
                  vs-lg="12"
                  vs-xs="12"
              >
                  <div class="text-right justify-center flex gap-4">
                      <vs-button
                          @click="cancel()"
                          color="danger"
                          type="flat"
                      >{{ $t('global.Cancel') }}
                      </vs-button>

                      <vs-button
                          @click="handleSubmit(submit)"
                          color="primary"
                          type="filled"
                      >{{ $t('buttons.Save') }}
                      </vs-button>
                  </div>
              </vs-col>
            </vs-row>
      </ValidationObserver>
    </template>

    <template v-else>
      <div class="automation">
        <ds-table
          :data="list"
          :heads="heads"
          :paginate="false"
          :max-items="list.length"
          class="automation__table"
          bordered
          spacer
          spacerGrey
        >
          <template #actions="{actions}">
            <vs-button
              v-tooltip="actions.is_active ? $t('global.pause') : $t('global.play')"
              class="mr-3"
              radius
              color="primary"
              type="flat"
              v-bind="actions.is_active ? $iconData('icon-pause', 'fi-rr-file-edit') : $iconData('icon-play', 'fi-rr-play')"
              @click.stop="playOrPause(actions)"
            />

            <vs-button
              v-tooltip="$t('global.edit')"
              class="mr-3"
              radius
              color="primary"
              type="flat"
              v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"
              @click="createOrEditAction(actions)"
            />

            <vs-button
              v-tooltip="$t('global.remove')"
              class="mr-3"
              radius
              color="primary"
              type="flat"
              v-bind="$iconData('icon-trash', 'fi-rr-trash-xmark')"
              @click="remove(actions.id)"
            />
          </template>

          <template #start="{start}">
            <div class="automation__date" v-if="start.last_started_at">
              <span>{{ start.last_started_at|date }}</span>
              <span>{{ start.last_started_at|time }}</span>
            </div>
            <span v-else>-</span>
          </template>

          <template #end="{end}">
            <div class="automation__date" v-if="end.last_finished_at">
              <span>{{ end.last_finished_at|date }}</span>
              <span>{{ end.last_finished_at|time }}</span>
            </div>
            <span v-else>-</span>
          </template>

          <template #params="{params}">
            <div class="automation__tags flex flex-wrap">
              <div class="automation__tag" v-if="params.data.select_leads.countries.length > 0">
                <div class="automation__tag-name">
                  <span>{{ $t('global.Countries') }}:</span>
                </div>

                <div
                  class="automation__tag-values"
                  v-for="(value, index) in params.data.select_leads.countries"
                  :key="index"
                >
                  <span>{{ getParamsName('countries', value) }}</span>
                </div>
              </div>

              <div class="automation__tag" v-if="params.data.select_leads.landings.length > 0">
                <div class="automation__tag-name">
                  <span>{{ $t('global.Landings') }}:</span>
                </div>

                <div
                  class="automation__tag-values"
                  v-for="(value, index) in params.data.select_leads.landings"
                  :key="index"
                >
                  <span>{{ getParamsName('landings', value) }}</span>
                </div>
              </div>

              <div class="automation__tag" v-if="params.data.select_leads.languages.length > 0">
                <div class="automation__tag-name">
                  <span>{{ $t('global.Languages') }}:</span>
                </div>

                <div
                  class="automation__tag-values"
                  v-for="(value, index) in params.data.select_leads.languages"
                  :key="index"
                >
                  <span>{{ getParamsName('languages', value) }}</span>
                </div>
              </div>

              <div class="automation__tag" v-if="params.data.select_leads.manager_ids.length > 0">
                <div class="automation__tag-name">
                  <span>{{ $t('global.Managers') }}:</span>
                </div>

                <div
                  class="automation__tag-values"
                  v-for="(value, index) in params.data.select_leads.manager_ids"
                  :key="index"
                >
                  <span>{{ getParamsName('managers', value) }}</span>
                </div>
              </div>

              <div class="automation__tag" v-if="params.data.select_leads.affiliate_ids.length > 0">
                <div class="automation__tag-name">
                  <span>{{ $t('global.Affiliates') }}:</span>
                </div>

                <div
                  class="automation__tag-values"
                  v-for="(value, index) in params.data.select_leads.affiliate_ids"
                  :key="index"
                >
                  <span>{{ getParamsName('affiliates', value) }}</span>
                </div>
              </div>

              <div class="automation__tag" v-if="params.data.select_leads.group_statuses.length > 0">
                <div class="automation__tag-name">
                  <span>{{ $t('global.Group_statuses') }}:</span>
                </div>

                <div
                  class="automation__tag-values"
                  v-for="(value, index) in params.data.select_leads.group_statuses"
                  :key="index"
                >
                  <span>{{ getParamsName('group_statuses', value) }}</span>
                </div>
              </div>

              <div class="automation__tag" v-if="params.data.select_leads.advertiser_integration_ids.length > 0">
                <div class="automation__tag-name">
                  <span>{{ $t('global.Integrations') }}:</span>
                </div>

                <div
                  class="automation__tag-values"
                  v-for="(value, index) in params.data.select_leads.advertiser_integration_ids"
                  :key="index"
                >
                  <span>{{ getParamsName('advertiser_integrations', value) }}</span>
                </div>
              </div>

              <div class="automation__tag">
                <div class="automation__tag-name">
                  <span>{{ $t('automation.relative_number_of_days_in_period_start') }}:</span>
                </div>

                <div class="automation__tag-values">
                  <span>{{ params.data.select_leads.relative_number_of_days_in_period_start }}</span>
                </div>
              </div>

              <div class="automation__tag">
                <div class="automation__tag-name">
                  <span>{{ $t('automation.relative_number_of_days_in_period_end') }}:</span>
                </div>

                <div class="automation__tag-values">
                  <span>{{ params.data.select_leads.relative_number_of_days_in_period_end }}</span>
                </div>
              </div>
            </div>
          </template>

          <template #options="{options}">
            <div class="automation__tags flex flex-wrap">

              <div class="automation__tag">
                <div class="automation__tag-name">
                  <span>{{ $t('global.Team') }}:</span>
                </div>

                <div class="automation__tag-values">
                  <span>{{ getParamsName('teams', options.data.recycle_leads_settings.team_id) }}</span>
                </div>
              </div>

              <div class="automation__tag">
                <div class="automation__tag-name">
                  <span>{{ $t('global.Integration') }}:</span>
                </div>

                <div class="automation__tag-values">
                  <span>{{ getParamsName('advertiser_integrations', options.data.recycle_leads_settings.advertiser_integration_id) }}</span>
                </div>
              </div>

              <div class="automation__tag">
                <div class="automation__tag-name">
                  <span>Per time:</span>
                </div>

                <div class="automation__tag-values">
                  <span>{{ options.data.recycle_leads_settings.leads_per_time }}</span>
                </div>
              </div>

              <div class="automation__tag">
                <div class="automation__tag-name">
                  <span>Timespan:</span>
                </div>

                <div class="automation__tag-values">
                  <span>{{ options.data.recycle_leads_settings.leads_timespan_in_minutes }}</span>
                </div>
              </div>

              <div class="automation__tag">
                <div class="automation__tag-name">
                  <span>{{ $t('automation.leads_count') }}</span>
                </div>

                <div class="automation__tag-values">
                  <span>{{ options.data.recycle_leads_settings.leads_count === null ? $t('global.All') : options.data.recycle_leads_settings.leads_count }}</span>
                </div>
              </div>
            </div>
          </template>
        </ds-table>

        <div class="automation__actions">
          <vs-button
            @click="createOrEditAction()"
            color="primary"
            type="filled"
          >{{ $t('global.create') }}
          </vs-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import send from '@/utils/fetch'
import ErrorHandler from "@/utils/errorHandler"
import vSelect from "vue-select"
import CronScheduler from "@/components/CronScheduler.vue";

export default {
  components: {
    CronScheduler,
    vSelect
  },

  data() {
    return {
      isCreateOrUpdate: false,
      fields: {
        leads_per_time: '1',
        leads_timespan_in_minutes: 1,
        leads_count: null,
        countries: [],
        cronExpression: undefined,
        country: null,
        language: null
      },
      list: [],
      options: {},
      optionsDays: [
        {label: 'calendar.weekdaysMin.Mo', value: 1},
        {label: 'calendar.weekdaysMin.Tu', value: 2},
        {label: 'calendar.weekdaysMin.We', value: 3},
        {label: 'calendar.weekdaysMin.Th', value: 4},
        {label: 'calendar.weekdaysMin.Fr', value: 5},
        {label: 'calendar.weekdaysMin.Sa', value: 6},
        {label: 'calendar.weekdaysMin.Su', value: 0},
      ],
      timespanOptions: [1, 3, 5, 7, 10],
      heads: [
        {name: 'automation.name', key: 'name', value: 'name', display: true, width: 'auto'},
        {name: 'global.leadSamplingParameters', key: 'params', value: 'params', display: true,},
        {name: 'global.sendingOptions', key: 'options', value: 'options', display: true, width: '280px'},
        {name: 'automation.start', key: 'start', value: 'start', display: true, width: 'auto', headerPosition: 'center'},
        {name: 'automation.end', key: 'end', value: 'end', display: true, width: 'auto', headerPosition: 'center'},
        {name: 'global.Actions', key: 'actions', value: 'actions', display: true, width: '150px', headerPosition: 'center'},
      ],
    }
  },

  computed: {
    optionsMonthDays() {
      return Array.from({length: 31}, (_, i) => i + 1)
    }
  },

  methods: {
    getParamsName(key, value) {
      const optionList = this.options[key]

      if (!Array.isArray(optionList)) {
        return value
      }

      const option = optionList.find(option => typeof option === 'object'
        && option.hasOwnProperty('id')
        && option.id === value
      )

      return !option ? value : option.name || ''
    },

    async submit() {
      try {
        const data = {
          type: "recycle_automation",
          cron_expression: this.fields.cronExpression,
          is_active: this.fields.hasOwnProperty('is_active') ? this.fields.is_active : true,
          name: this.fields.name,
          data: {
            select_leads: {
              advertiser_integration_ids: this.fields.advertiser_integration_ids || [],
              group_statuses: this.fields.group_statuses || [],
              affiliate_ids: this.fields.affiliate_ids || [],
              landings: this.fields.landings || [],
              countries: this.fields.countries || [],
              languages: this.fields.languages || [],
              manager_ids: this.fields.manager_ids || [],
              relative_number_of_days_in_period_start: this.fields.relative_number_of_days_in_period_start || 0,
              relative_number_of_days_in_period_end: this.fields.relative_number_of_days_in_period_end || 0
            },
            recycle_leads_settings: {
              team_id: this.fields.team_id,
              affiliate_id: this.fields.affiliate_id,
              advertiser_integration_id: this.fields.advertiser_integration_id,
              country: this.fields.country,
              language: this.fields.language,
              leads_per_time: this.fields.leads_per_time,
              leads_timespan_in_minutes: this.fields.leads_timespan_in_minutes,
              leads_count: this.fields.leads_count
            }
          }
        }

        if (this.fields.id) {
          await send(`${this.$url.recycle.updateAutomation}/${this.fields.id}`, 'PATCH', {data})
        } else {
          await send(this.$url.recycle.createAutomation, 'POST', {data})
        }

        this.cancel()
        this.list = await this.getList()
      } catch (e) {
        new ErrorHandler(e).send
      }
    },

    async playOrPause(item) {
      try {
        await send(`${this.$url.recycle.updateAutomation}/${item.id}`, 'PATCH', {
          data: {
            ...item,
            is_active: !item.is_active,
          }
        })

        this.list = await this.getList()
      } catch (e) {
        new ErrorHandler(e).send
      }
    },

    onKeypress(event, int = false) {
      const regex = int ? /^[0-9]$/ : /^[0-9.,]$/
      if (!regex.test(event.key)) {
        event.preventDefault()
      }
    },

    onKeypressInput(data, name) {
      if (typeof data !== "number" || !data) {
        this.fields[name] = 0
      }
    },

    onKeypressNullableInput(data, name) {
      if (typeof data !== "number" || !data) {
        this.fields[name] = null
      }
    },

    getList() {
      return send(this.$url.recycle.getScheduledTasks, 'GET', {
        params: {
          'filter[type]': 'recycle_automation'
        }
      })
          .then(response => response.data.result.scheduled_tasks || [])
    },

    createOrEditAction(item) {
      try {
        const isCreate = item === undefined

        if (isCreate) {
          this.isCreateOrUpdate = true
          this.fields.cronExpression = '00 00 * * *'
        } else {
          this.fields = {
            id: item.id,
            is_active: item.is_active,
            name: item.name,
            ...(item.data.recycle_leads_settings || {}),
            ...(item.data.select_leads || {})
          }

          this.isCreateOrUpdate = true
          this.fields.cronExpression = item.cron_expression
        }
      } catch (e) {
        new ErrorHandler(e).send
      }
    },

    remove(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: this.$t('confirm.Confirm_action'),
        text: this.$t('confirm.removeAutomation'),
        accept: async () => {
          await send(`${this.$url.recycle.removeAutomation}/${id}`, 'DELETE')

          this.list = await this.getList()
        },
        acceptText: this.$t('buttons.Delete'),
        cancelText: this.$t('global.Cancel')
      })

    },

    cancel() {
      this.fields = {
        leads_per_time: '1',
        leads_timespan_in_minutes: 1,
      }
      this.isCreateOrUpdate = false
    }
  },

  async mounted() {
    try {
      const [option, list] = await Promise.all([
        send(this.$url.recycle["recycle-automation-filters"], 'GET')
            .then(response => response.data.result || []),

        this.getList()
      ])

      option.advertiser_integrations = option.advertiser_integrations.map(item => {
        return {
          id: item.id,
          name: [item.name, item.advertiser_name].join(' / ')
        }
      })

      this.options = option
      this.list = list

      this.$store.commit('UPDATE_LOADER_STATE', false)
    } catch (e) {
      this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
      new ErrorHandler(e).send
    }
  }
}
</script>

<style scoped lang="scss">
.automation {
  height: 100%;
  margin-inline: 1rem;
  display: flex;
  flex-direction: column;

  &__table {
    flex: 1;
    overflow-y: auto;

    .automation__tags {
      flex-direction: column;

      .automation__tag {
        display: flex;
        border-radius: 5px;
        flex-wrap: wrap;

        &-name {
          vertical-align: middle;
          padding: 5px;
          display: flex;
          align-items: center;

          span {
            font-size: 14px;
            text-decoration: underline;
          }
        }

        &-values {
          padding: 5px;
          display: flex;
          gap: 8px;

          span {
            padding: 2px 7px;
            background-color: #1d1525;
            border-radius: 3px;
            color: #ffffff;
            font-size: 12px;
          }
        }
      }
    }
  }

  &__form {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 20px;
  }

  &__tabs {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__tab {
    cursor: pointer;

    &--active {
      color: rgba(var(--vs-primary), 1);
      text-decoration: underline;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  &__actions {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    padding-inline: 0.5rem;
    position: sticky;
    bottom: 0;
    background: white;
    border-top: 2px solid rgba(0, 0, 0, 0.06);
    z-index: 100;
  }

  &__title {
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  &__date {
    display: flex;
    gap: 5px;
  }

  &__width {
    max-width: 320px;
    width: 100%;
  }

  &__cron {
    &-days {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    &-day {
      width: 30px;
      height: 30px;
      border-radius: 9999px;
      cursor: pointer;
      border: 1px solid rgba(60, 60, 60, 0.26);
      display: flex;
      align-items: center;
      justify-content: center;

      &--active {
        background-color: rgba(var(--vs-primary), 1);
        color: white;
      }

      &:hover:not(&--active) {
        background-color: rgba(var(--vs-primary), 0.05);
        transition: background-color .2s ease;
      }
    }
  }
}
</style>
